import Backbone from 'backbone';

const YesNoReviewModel = Backbone.Model.extend({
  toJSON() {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'IArguments' is not assignable to... Remove this comment to see the full error message
    const json = Backbone.Model.prototype.toJSON.apply(this, arguments);

    if (json.choice === 'Yes') {
      delete json.explanation;
    }

    return json;
  },
});

export default YesNoReviewModel;
